import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import AdeIcon from "assets/icons/ade.svg?react";

const AdeCell: FC<Props> = ({ element }) => {

  return (
    <div className={styles.wrapper}>
      {(element.EDelivery?.Addresses ?? 0) > 0 && <AdeIcon></AdeIcon>}
    </div>
  );
};

export default AdeCell;
